import { Component } from '@angular/core';

@Component({
    selector: 'qms-page-footer',
    templateUrl: './page-footer.component.html',
    styleUrls: [
        './page-footer.component.css'
    ]
})
export class PageFooterComponent {
    private static SYSTEM_CREATION_YEAR = 2017;

    private today: Date;

    constructor() {
        this.today = new Date();
    }

    public getYear(): string {
        const year = this.today.getFullYear();
        return ((year === PageFooterComponent.SYSTEM_CREATION_YEAR) ?
            '' : PageFooterComponent.SYSTEM_CREATION_YEAR + '-') + year;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/main/footer/page-footer.component.ts